import { z } from "zod";
import { AgencyIdSchema } from "../../primitives/ids.js";
import { DeliveryProjectIdSchema } from "./entities.js";
export const CONTROLLED_FOLLOW_UP_ACTION_KINDS = [
    "STATUS_CHECK",
    "CLIENT_REMINDER",
    "INTERNAL_NUDGE",
];
export const ControlledFollowUpActionV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.controlled-follow-up.v1.0"),
    actionId: z.string().regex(/^wdfu_[a-zA-Z0-9_-]+$/),
    agencyId: AgencyIdSchema,
    deliveryProjectId: DeliveryProjectIdSchema,
    kind: z.enum(CONTROLLED_FOLLOW_UP_ACTION_KINDS),
    message: z.string().min(1).max(500),
    scheduledFor: z.string().datetime(),
    status: z.enum(["SCHEDULED", "COMPLETED", "CANCELLED"]),
    createdAt: z.string().datetime(),
})
    .strict();
const FORBIDDEN_BROAD_CRM_KINDS = new Set([
    "MASS_EMAIL",
    "DRIP_SEQUENCE",
    "LEAD_SCORING",
    "PIPELINE_AUTOMATION",
]);
export function scheduleControlledFollowUpAction(input) {
    if (FORBIDDEN_BROAD_CRM_KINDS.has(input.kind)) {
        throw new Error("broad_crm_automation_forbidden");
    }
    return ControlledFollowUpActionV1Schema.parse({
        schemaVersion: "clientops.controlled-follow-up.v1.0",
        actionId: input.actionId,
        agencyId: input.agencyId,
        deliveryProjectId: input.deliveryProjectId,
        kind: input.kind,
        message: input.message,
        scheduledFor: input.scheduledFor,
        status: "SCHEDULED",
        createdAt: input.now ?? new Date().toISOString(),
    });
}
//# sourceMappingURL=follow-up.js.map